import { useMemo } from 'react';
import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
/**
 * This represents the current state of the document.
 */
export const documentState = makeVar(undefined);
export function useDocumentState() {
    const state = useReactiveVar(documentState);
    return useMemo(() => state, [state]);
}
